import React, { FC, useCallback } from 'react'
import styles from 'styles/components/template.module.scss'
import format from 'date-fns/format'
import { Spacer } from 'components/Utility'
import { GreyButton, OrangeButton } from 'components/Button'
import { Headline, MainHeadline } from 'components/Typography'
import { useDispatch, useSelector } from 'react-redux'
import { AlertCard, CampaignBreadCard, Card, CardGreyHeadline, CardOutlined, CardOutlinedInner } from 'components/Card'
import { push } from 'connected-react-router'
import { State } from 'index'
import { getConfirmCampaign } from 'reducks/campaign/selectors'
import { CAMPAIGN_STATUS } from 'constants/campaign'
import { CampaignStatus } from 'types/campaign'
import { PreviewImage } from 'components/Image'
import { useQueryBreads } from 'hooks/campaign'
import { BreadType } from 'types/bread'
import { saveCampaign } from 'reducks/campaign/operations'
import { getBreadShortName } from 'lib/helper'

const CampaignConfirmTemplate: FC = () => {
  const dispatch = useDispatch()
  const confirm = useSelector((state: State) => getConfirmCampaign(state))
  const backToEditPage = useCallback(() => {
    dispatch(push(`/admin/campaign_cms/${confirm.campaign_id}`))
  }, [confirm])

  const breads: BreadType[] = useQueryBreads(confirm.bread_ids)

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'登録内容を確認する'} />
      <Spacer size={20} />
      <AlertCard
        headline={
          '公開ステータスが「公開」かつ掲載期間内のものは、アプリ側に即時反映されるため登録内容にはご注意ください'
        }
        title={'注意'}
      />
      <Spacer size={16} />
      <Headline headline={'登録内容'} />
      <Spacer size={16} />
      <CardOutlined>
        <CardGreyHeadline headline={'キャンペーン名'} isTop={true} />
        <Spacer size={8} />
        <CardOutlinedInner>{confirm.name}</CardOutlinedInner>
        <Spacer size={8} />
        <CardGreyHeadline headline={'バナー画像'} isTop={true} />
        <Spacer size={8} />
        <CardOutlinedInner>
          <PreviewImage imageUrl={confirm.banner} alt={'バナー画像'} />
        </CardOutlinedInner>
        <CardGreyHeadline headline={'メインビジュアル'} isTop={true} />
        <Spacer size={8} />
        <CardOutlinedInner>
          <PreviewImage imageUrl={confirm.main_visual} alt={'メインビジュアル'} />
        </CardOutlinedInner>
        <CardGreyHeadline headline={'背景リピート'} isTop={true} />
        <Spacer size={8} />
        <CardOutlinedInner>
          <img src={confirm.background} alt={'背景リピート'} width={64} height={64} />
        </CardOutlinedInner>
        <CardGreyHeadline headline={'掲載開始日'} isTop={true} />
        <Spacer size={8} />
        <CardOutlinedInner>{format(confirm.period_start.toDate(), 'yyyy年M月d日 HH:mm')}</CardOutlinedInner>
        <Spacer size={8} />
        <CardGreyHeadline headline={'掲載終了日'} isTop={true} />
        <Spacer size={8} />
        <CardOutlinedInner>{format(confirm.period_end.toDate(), 'yyyy年M月d日 HH:mm')}</CardOutlinedInner>
        <Spacer size={8} />
        <CardGreyHeadline headline={'公開ステータス'} isTop={true} />
        <Spacer size={8} />
        <CardOutlinedInner>{CAMPAIGN_STATUS[confirm.status as CampaignStatus]}</CardOutlinedInner>
        <Spacer size={8} />
      </CardOutlined>
      <Spacer size={20} />
      <MainHeadline headline={'紹介する商品'} />
      <Spacer size={20} />
      {breads.length > 0 ? (
        breads.map((bread, index) => {
          if (!bread.bread_ref) return
          return (
            <React.Fragment key={bread.bread_ref.id}>
              <Card>
                <CampaignBreadCard
                  breadRef={bread.bread_ref}
                  breadName={getBreadShortName(bread)}
                  isTypeDaily={bread.is_type_daily}
                  isTypePreorder={bread.is_type_preorder}
                  isTypeDelivery={!!bread.is_type_delivery}
                  imageUrl={bread.image_urls[0] || ''}
                />
              </Card>
              {index !== breads.length - 1 && <Spacer size={20} />}
            </React.Fragment>
          )
        })
      ) : (
        <p>紹介する商品が設定されていません。</p>
      )}
      <Spacer size={48} />
      <OrangeButton label={'登録する'} onClick={() => dispatch(saveCampaign(confirm))} size={'medium'} type={'main'} />
      <Spacer size={20} />
      <GreyButton label={'キャンペーン作成画面に戻る'} onClick={backToEditPage} size={'medium'} type={'outlined'} />
      <Spacer size={72} />
    </div>
  )
}

export default CampaignConfirmTemplate
